import type { PropsWithChildren } from "react";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface ListProps {
  className?: string;
  title: string;
}

export const List = ({
  title,
  children,
  className,
}: PropsWithChildren<ListProps>) => (
  <div className={classNames("flex flex-col gap-y-3", className)}>
    <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
    <div className="flex flex-col gap-y-1">{children}</div>
  </div>
);
